// Client-portal API helper (Track A / A6, 6 Sep 2026).
// Separate token from the staff `ats_token`: a client session must never be
// mistaken for a staff session in the browser either.

const API_URL = process.env.REACT_APP_BACKEND_URL;
export const PORTAL_TOKEN_KEY = 'client_portal_token';
export const PORTAL_USER_KEY = 'client_portal_user';

export const getPortalToken = () => {
  try { return localStorage.getItem(PORTAL_TOKEN_KEY); } catch { return null; }
};

export const getPortalUser = () => {
  try { return JSON.parse(localStorage.getItem(PORTAL_USER_KEY) || 'null'); } catch { return null; }
};

export const setPortalSession = (token, user, client) => {
  try {
    localStorage.setItem(PORTAL_TOKEN_KEY, token);
    localStorage.setItem(PORTAL_USER_KEY, JSON.stringify({ ...user, client }));
  } catch { /* storage unavailable */ }
};

export const clearPortalSession = () => {
  try {
    localStorage.removeItem(PORTAL_TOKEN_KEY);
    localStorage.removeItem(PORTAL_USER_KEY);
  } catch { /* ignore */ }
};

export class PortalApiError extends Error {
  constructor(status, detail) {
    super(detail || `Request failed (${status})`);
    this.status = status;
    this.detail = detail;
  }
}

// portalFetch('/requirements') -> parsed JSON; throws PortalApiError with .status
export async function portalFetch(path, { method = 'GET', body, auth = true } = {}) {
  const headers = { 'Content-Type': 'application/json' };
  const token = getPortalToken();
  if (auth && token) headers.Authorization = `Bearer ${token}`;
  const res = await fetch(`${API_URL}/api/client-portal${path}`, {
    method,
    headers,
    body: body !== undefined ? JSON.stringify(body) : undefined
  });
  let data = null;
  try { data = await res.json(); } catch { data = null; }
  if (!res.ok) {
    const detail = data && (typeof data.detail === 'string' ? data.detail : JSON.stringify(data.detail));
    throw new PortalApiError(res.status, detail);
  }
  return data;
}

// Staff-side helper (uses the staff ats_token) for the Client Hub card.
export async function staffPortalFetch(path, { method = 'GET', body } = {}) {
  const headers = { 'Content-Type': 'application/json' };
  let token = null;
  try { token = localStorage.getItem('ats_token'); } catch { token = null; }
  if (token) headers.Authorization = `Bearer ${token}`;
  const res = await fetch(`${API_URL}/api/client-portal${path}`, {
    method,
    headers,
    body: body !== undefined ? JSON.stringify(body) : undefined
  });
  let data = null;
  try { data = await res.json(); } catch { data = null; }
  if (!res.ok) {
    const detail = data && (typeof data.detail === 'string' ? data.detail : JSON.stringify(data.detail));
    throw new PortalApiError(res.status, detail);
  }
  return data;
}

export const PORTAL_OFF_MESSAGE = 'Client portal is switched off';
